export const substringWithoutSpace = (string = '') => {
  const str = string.split(' ')[0];
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const returnSearchParams = search => {
  return JSON.parse(
    '{"' + decodeURI(search.substring(1).replace(/&/g, '","').replace(/=/g, '":"')) + '"}'
  );
};

export const simplifyString = (attrnames, convert = true) => {
  const attr = attrnames
    .replaceAll(/&/g, '')
    .replaceAll(/\s+/g, ' ')
    .trim()
    .replaceAll(/ /g, '-')
    .replaceAll(/,/g, '-')
    .replaceAll(/--/g, '-')
    .replaceAll(/---/g, '-');
  return convert ? attr.toLowerCase() : attr;
};
